import React from "react";
import { t, GO_BACK_TO_HOME } from "../../translations/Edit";
const AlertSuccess = (props) => {
    const { msg, className = "", type } = props;
    return (
        <div className="alert">
            <div
                className={`confirmation ${className}`}
                onClick={(e) => e.stopPropagation()}
                style={{ background: '#E0EFD8', paddingBottom: '20px' }}
            >
                <div
                    className="alert--content success"
                    style={{ width: "100%", padding: "20px 20px 10px 20px", background: '#E0EFD8' }}
                >
                    {msg}
                </div>
                {(type === 'sendEmail' || type === 'txn_pwd') ?
                    <div className="go-to-home" onClick={() => close && props.close()}>OK</div>
                    :
                    <div className="go-to-home" onClick={() => window.location.href = "/"}>{t(GO_BACK_TO_HOME)}</div>
                }
            </div>
        </div>
    );
};

export default AlertSuccess;
